export function distinctArray<T>(arr: T[], prop: keyof T): T[] {
  return Array.from(new Map(arr.map((obj: T) => [obj[prop], obj])).values());
}
